import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TaxonomyAttachmentTypeModel, TaxonomyDocumentTemplateModel } from 'e5core-angular-services';

export class E5coreUiGenerateDocumentBaseComponent implements OnInit {
  
  @Input()
  set attachmentTypes(attachmentTypes: TaxonomyAttachmentTypeModel[]) {
    this._attachmentTypes = attachmentTypes;
    this.hasAttachments = attachmentTypes.length > 0;
  }
   get attachmentTypes(): TaxonomyAttachmentTypeModel[] { return this._attachmentTypes; }

  @Input() documentTemplates: TaxonomyDocumentTemplateModel[];
  @Input() showGenerateButton: boolean;
  @Input() readonly: boolean;

  @Output() selectDocumentTemplateEvent = new EventEmitter();
  @Output() selectAttachmentTypeEvent = new EventEmitter();
  @Output() generateDocumentEvent = new EventEmitter();

  _attachmentTypes: TaxonomyAttachmentTypeModel[];
  hasAttachments: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  public onGenerateDocument(): void {
    this.generateDocumentEvent.emit(null);
  }

  public onSelectDocumentTemplate(event): void {
    this.selectDocumentTemplateEvent.emit(event);
  }

  public onSelectAttachmentType(event): void {
    this.selectAttachmentTypeEvent.emit(event);
  }
  
  public get isReadOnly(): boolean {
    return (this.readonly);
  }
}
